import {field} from "../../stem-core/state/StoreField";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {Merchant} from "./MerchantStore";
import {MerchantEmailSender} from "./merchant/MerchantEmailSender";
import {MerchantEmailCampaign} from "./merchant/MerchantEmailCampaignStore";


@makeEnum
export class EmailTemplateType extends BaseEnum {
    static CUSTOM; // A custom merchant defined template
    static CAMPAIGN;
    static AUTH_LOGIN_CODE;
    static CHANGE_EMAIL_CONFIRM;
    static CHANGE_EMAIL_UNDO;
    static DONATION_SUCCESS;
    static DONATION_CANCEL;
    static SUBSCRIPTION_SUCCESS;
    static SUBSCRIPTION_GIFT_SUCCESS_BILLED_USER;
    static SUBSCRIPTION_GIFT_SUCCESS_BENEFICIARY;
}


@globalStore
export class EmailTemplate extends BaseStore("EmailTemplate") {
    @field(String) name: string;
    @field(EmailTemplateType) type: EmailTemplateType;
    @field("Merchant") merchant: Merchant;
    @field("MerchantEmailSender") emailSender: MerchantEmailSender;
    @field("MerchantEmailCampaign") campaign: MerchantEmailCampaign;
    @field(String) replyTo: string;
    @field(Array) bccEmails: string[];
    @field(String) subject: string;
    @field(String) html: string;
    @field(String) plainText: string;
    @field(Boolean) isTypeDefault: boolean;

    toString(): string {
        return this.name;
    }
}


export async function apiCreateEmailTemplate(request: any): Promise<EmailTemplate> {
    const response = await apiClient.post("/mailing/create_template", request);
    return EmailTemplate.loadObject(response);
}

export async function apiUpdateEmailTemplate(request: any): Promise<any> {
    return apiClient.post("/mailing/update_template", request);
}

export async function apiRenderEmailTemplate(data: any): Promise<any> {
    return apiClient.post("/mailing/render_template", data);
}

export async function apiSendTestEmailTemplate(data: any): Promise<any> {
    return apiClient.post("/mailing/send_test_email", data);
}
